import PropTypes from "prop-types";
import React, { useState } from "react";

import "react-reflex/styles.css";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { makeStyles } from "tss-react/mui";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import MuiTooltip from "@mui/material/Tooltip";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DataTable from "./DataTable";

const useStyles = makeStyles()((theme) => ({
  resultDetail: {
    fontSize: "0.8rem",
    textAlign: "center",
    padding: "0 10px",
  },
}));

ResultTabs.propTypes = {
  queryResultState: PropTypes.object,
  memoizedOpenSavePopup: PropTypes.func,
  height: PropTypes.string,
  getNextResults: PropTypes.func,
  external: PropTypes.bool,
};

function ResultTabs({ queryResultState, memoizedOpenSavePopup, height, getNextResults, external = false }) {
  const { queryResultColumns, queryResult, queryError, timeTaken, queryResultLoding, downloading } = queryResultState;
  const [loading, setLoading] = useState(false);

  const { classes } = useStyles();

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f2f2f2",
          display: "flex",
          alignItems: "center",
          minHeight: "40px",
          maxHeight: "40px",
        }}
      >
        {queryResultColumns.length || queryError !== "" ? (
          <>
            <Box
              sx={{
                flexGrow: "1",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Box display="flex" alignItems={"center"}>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "bolder",
                    textAlign: "center",
                    padding: "0 10px",
                  }}
                >
                  Results
                </Typography>
                {timeTaken && (
                  <Typography
                    className={classes.resultDetail}
                    sx={{
                      minWidth: "140px",
                    }}
                    noWrap
                  >
                    Time Taken: {timeTaken}
                  </Typography>
                )}
                {queryError === "" ? (
                  <>
                    <Typography
                      className={classes.resultDetail}
                      sx={{
                        borderRight: "1px solid black",
                        borderLeft: "1px solid black",
                        minWidth: "70px",
                      }}
                      noWrap
                    >
                      {`${external ? "First " : ""}${queryResult.length}`} Rows
                    </Typography>
                    <Typography
                      className={classes.resultDetail}
                      sx={{
                        borderRight: "1px solid black",
                        minWidth: "70px",
                      }}
                      noWrap
                    >
                      {queryResultColumns.length} Columns
                    </Typography>
                  </>
                ) : (
                  ""
                )}
              </Box>
            </Box>
            {queryResult.length && typeof memoizedOpenSavePopup === "function" ? (
              <Box>
                <MuiTooltip title="Export data to csv" placement="left">
                  <IconButton color="success" onClick={memoizedOpenSavePopup} disabled={downloading}>
                    {downloading ? <CircularProgress style={{ width: "1em", height: "1em" }} /> : <FileDownloadIcon />}
                  </IconButton>
                </MuiTooltip>
              </Box>
            ) : (
              ""
            )}
          </>
        ) : (
          <Box
            sx={{
              flexGrow: "1",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Box display="flex" alignItems={"center"}>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: "bolder",
                  textAlign: "center",
                  padding: "0 10px",
                }}
              >
                Results
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      {queryResultLoding ? (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            minHeight: "200px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <DataTable
          queryResultColumns={queryResultColumns}
          queryResult={queryResult}
          queryError={queryError}
          height={height}
          loading={loading}
          fetchMoreData={
            queryResultState?.fetchMore
              ? async () => {
                  setLoading(true);
                  await getNextResults(queryResultState?.id, queryResultState?.queryId);
                  setLoading(false);
                }
              : undefined
          }
        />
      )}
    </>
  );
}

export default ResultTabs;
